import http from '@/lib/axios';

/**
 * @typedef {Object} SdkInfo
 * @property {string} userId 用户 appmid
 * @property {number} loginType 绑定类型，对应账号 sdk 端登录 companyId
 * @property {string} token 登录态
 * @property {string} ticket 登录小票
 */

/**
 * @description SDK2 Web 票据登录
 * @param {Record<'channel' | 'sdk2WebTicket', string>} data
 * @returns {Promise<SdkInfo>}
 */
export async function sdk2WebLogin(data) {
    return http.post('web/account/sdk2WebLogin', data);
}

/**
 * @typedef {Object} RevokeInit
 * @property {string} flowId 账号注销业务流程 id
 * @property {number} showAcctDeletionAgreement 是否展示注销协议，0不展示，1展示，默认1
 * @property {string} acctDeletionAgreementUrl 注销协议url
 * @property {number} hesitation 是否存在犹豫期，0不存在，1存在，默认1
 * @property {number} hesitationDuration 犹豫期长短，默认30天
 */

/**
 * @description 账号注销初始化
 * @param {string} channel
 * @returns {Promise<RevokeInit>}
 */
export async function revokeInit(channel) {
    return http.post('web/acctDeletion/init', { channel });
}

/**
 * @typedef {Object} RevokeInfo
 * @property {string} loginType 注销账号登录类型，即 companyId，nextAction = 0 或 3 返回
 * @property {string} userId 已注销用户appmid，nextAction=0或3返回
 * @property {string} commitTime 注销（登记）时间
 */

/**
 * @description 账号注销邮箱验证码确认
 * @param {Record<'flowId' | 'emailCode' | 'hash', string>} form
 * @returns {Promise<RevokeInfo & { nextAction: string }>}
 */
export async function revokeCaptchaCheck(form) {
    return http.post('web/acctDeletion/emailCodeCheck', form);
}

/**
 * @description 账号注销 apple revokeToken
 * @param {Record<'flowId' | 'authorizationCode', string>} params authorizationCode-apple 账号注销授权码
 * @returns {Promise<RevokeInfo>}
 */
export async function revokeIOS(data) {
    return http.post('web/acctDeletion/revokeToken', data);
}

/**
 * @description 账号同意犹豫期并进行注销登记
 * @param {string} flowId
 * @returns {Promise<RevokeInfo>}
 */
export async function hesitate(flowId) {
    return http.post('web/acctDeletion/confirm', { flowId });
}
